import { render, staticRenderFns } from "./AuthorsDropdown.vue?vue&type=template&id=08e218e6&"
import script from "./AuthorsDropdown.vue?vue&type=script&lang=ts&"
export * from "./AuthorsDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports